<template>
    <div class='page'>
        <el-form
            v-if='isSearch'
            :model='queryForm'
            ref='searchForm'
            label-width='80px'
            :inline='true'
            size='small'
            class='query-form'
            @submit.native.prevent
        >
            <el-form-item label='商品名称' prop='keywords'>
                <el-input
                    v-model='queryForm.keywords'
                    style='width: 177px'
                    placeholder='请输入商品名称'
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item label='状态' prop='handleStatus'>
                <el-select
                    v-model='queryForm.handleStatus'
                    style='width: 177px'
                    placeholder='请选择状态'
                    clearable
                >
                    <el-option label='待处理' :value='0'></el-option>
                    <el-option label='已处理' :value='1'></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label='创建时间'>
                <el-date-picker
                    v-model='createTimeRange'
                    style='width: 340px'
                    type='datetimerange'
                    format='yyyy-MM-dd HH:mm:ss'
                    value-format='yyyy-MM-dd HH:mm:ss'
                    range-separator='-'
                    start-placeholder='开始时间'
                    end-placeholder='结束时间'
                ></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type='primary' icon='el-icon-search' size='small' @click='handleSearch'>查询</el-button>
                <el-button icon='el-icon-refresh' size='small' @click='handleReset'>重置</el-button>
            </el-form-item>
        </el-form>
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'></div>
                <div class='icon-group'>
                    <span class='icon-box' title='搜索' @click='toggleSearch'>
                        <Icon color='#606266'>
                            <Search />
                        </Icon>
                    </span>
                    <span class='icon-box' title='刷新' @click='refreshList'>
                        <Icon color='#606266'>
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <el-table
                height='100%'
                :data='tableData.list'
                row-key='id'
                border
                v-loading='tableLoading'
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                size='small'
            >
                <el-table-column align='center' prop='productId' label='商品ID' min-width='160' show-overflow-tooltip></el-table-column>
                <el-table-column align='center' prop='productName' label='商品名称' min-width='160' show-overflow-tooltip></el-table-column>
                <el-table-column align='center' prop='remoteCostPrice' label='平台成本价' min-width='160' show-overflow-tooltip></el-table-column>
                <el-table-column align='center' prop='localCostPrice' label='微维宝成本价' min-width='160' show-overflow-tooltip></el-table-column>
                <el-table-column align='center' prop='diffAmount' label='差异金额' min-width='160' show-overflow-tooltip></el-table-column>
                <el-table-column align='center' prop='handleStatus' label='状态' min-width='100'>
                    <template slot-scope='scope'>
                        <el-tag v-if='scope.row.handleStatus === 0' type='warning'>待处理</el-tag>
                        <el-tag v-else-if='scope.row.handleStatus === 1' type='success'>已处理</el-tag>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column align='center' prop='createTime' label='创建时间' min-width='160'></el-table-column>
                <el-table-column align='center' prop='handleRemark' label='备注' min-width='160'></el-table-column>
                <el-table-column align='center' label='操作' min-width='160' fixed='right'>
                    <template slot-scope='scope'>
                        <el-button
                            v-if='scope.row.handleStatus === 0'
                            type='text'
                            size='small'
                            @click='openHandleDialog(scope.row)'
                        >处理</el-button>
                        <el-button v-else type='text' size='small' disabled>已处理</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='(size) => { queryForm.pageSize = size; getTableData(); }'
                    @current-change='(page) => { queryForm.pageNum = page; getTableData(); }'
                    :current-page='queryForm.pageNum'
                    :page-sizes='[10, 20, 50, 100]'
                    :page-size='queryForm.pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    background
                    :total='tableData.total'>
                </el-pagination>
            </div>
        </div>
        <el-dialog
            :visible.sync='handleDialogVisible'
            title='处理'
            width='30vw'
            :before-close='closeHandleDialog'
        >
            <el-form ref='handleForm' :model='handleForm' label-width='80px' size='small'>
                <el-form-item label='备注' prop='handleRemark'>
                    <el-input
                        v-model='handleForm.handleRemark'
                        type='textarea'
                        :rows='4'
                        placeholder='请输入备注'
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot='footer' class='dialog-footer'>
                <el-button type='primary' :loading='handleLoading' @click='confirmHandle'>确定</el-button>
                <el-button @click='closeHandleDialog'>取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { Refresh, Search } from '@v2icons/tabler';
import { get, postJson } from '@/utils/request.js';

export default {
    name: 'ProductDifferentiation',
    components: {
        Refresh,
        Search
    },
    data() {
        return {
            isSearch: false,
            createTimeRange: null,
            queryForm: {
                pageNum: 1,
                pageSize: 10,
                keywords: '',
                handleStatus: ''
            },
            tableData: {
                list: [],
                total: 0
            },
            tableLoading: false,
            handleDialogVisible: false,
            handleLoading: false,
            handleForm: {
                id: '',
                handleRemark: ''
            }
        };
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        toggleSearch() {
            this.isSearch = !this.isSearch;
        },
        buildQueryParams() {
            const params = { ...this.queryForm };
            params.startCreateTime = this.createTimeRange ? this.createTimeRange[0] : '';
            params.endCreateTime = this.createTimeRange ? this.createTimeRange[1] : '';
            return params;
        },
        getTableData() {
            this.tableLoading = true;
            get('/shop/manage/supplycostdiff/findList', this.buildQueryParams()).then((res) => {
                if (res.success) {
                    if (res.page) {
                        this.tableData.list = res.page.list;
                        this.tableData.total = res.page.total;
                    } else {
                        this.tableData.list = res.list || [];
                        this.tableData.total = this.tableData.list.length;
                    }
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            }).finally(() => {
                this.tableLoading = false;
            });
        },
        handleSearch() {
            this.queryForm.pageNum = 1;
            this.getTableData();
        },
        handleReset() {
            this.queryForm.keywords = '';
            this.queryForm.handleStatus = '';
            this.queryForm.pageNum = 1;
            this.createTimeRange = null;
            this.getTableData();
        },
        refreshList() {
            this.getTableData();
        },
        openHandleDialog(row) {
            this.handleForm = {
                id: row.id,
                handleRemark: ''
            };
            this.handleDialogVisible = true;
        },
        closeHandleDialog() {
            this.handleDialogVisible = false;
            this.handleForm = {
                id: '',
                handleRemark: ''
            };
        },
        confirmHandle() {
            this.handleLoading = true;
            postJson('/shop/manage/supplycostdiff/handle', {
                id: this.handleForm.id,
                handleRemark: this.handleForm.handleRemark
            }).then((res) => {
                if (res.success) {
                    this.$message({
                        message: res.msg || '处理成功',
                        type: 'success',
                        duration: 2000
                    });
                    this.closeHandleDialog();
                    this.getTableData();
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            }).finally(() => {
                this.handleLoading = false;
            });
        }
    }
};
</script>

<style scoped></style>
